import { Draggable, DraggableStateSnapshot } from '@hello-pangea/dnd';
import { Box, SxProps, Theme } from '@mui/material';

import { SignatureOrderType, SignatureOrderUser, SignerData } from '../../types/taskForm';
import { DragAndDropSignerBox } from './DragAndDropSignerBox';
import { generateGroupId } from './utils';

export interface DragAndDropSignerGroupBoxProps {
  signers: SignatureOrderUser[];
  index: number;
  isDragDisabled: boolean;
  usersData: Record<string, SignerData>;
  onSignerDelete: (signerId: string | number) => void;
  handleUnGroup?: (signerId: string | number, index: number) => void;
}

const customStyles: Record<string, SxProps<Theme>> = {
  combiningContainer: {
    border: (theme) => `1px solid ${theme.palette.primary.main}`,
    padding: '10px',
    borderRadius: '8px',
    gap: '10px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: (theme) => theme.palette.action.hover,
    overflow: 'visible',
  },
  groupContainer: {
    border: (theme) => `1px solid ${theme.palette.grey[400]}`,
    padding: '10px',
    borderRadius: '8px',
    gap: '10px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible',
  },
};

export function DragAndDropSignerGroupBox({
  signers,
  index,
  isDragDisabled,
  usersData,
  onSignerDelete,
  handleUnGroup,
}: DragAndDropSignerGroupBoxProps) {
  const groupId = generateGroupId(signers);

  return (
    <Draggable
      key={groupId}
      draggableId={groupId}
      index={index}
      isDragDisabled={isDragDisabled}
    >
      {(provided, snapshot: DraggableStateSnapshot) => (
        <Box
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          sx={
            {
              ...(snapshot.combineTargetFor
                ? customStyles.combiningContainer
                : signers.length > 1
                ? customStyles.groupContainer
                : {}),
            } as SxProps<Theme>
          }
        >
          {signers.map((signer) => (
            <DragAndDropSignerBox
              key={signer.id}
              signer={[signer]}
              index={index}
              usersData={usersData}
              onSignerDelete={onSignerDelete}
              orderType={SignatureOrderType.SEQUENTIAL}
              signers={signers}
              handleUnGroup={handleUnGroup}
              snapshot={snapshot}
            />
          ))}
        </Box>
      )}
    </Draggable>
  );
}
